import { useQuery } from '@tanstack/react-query';

import type { DeploymentsByRunIdsResponse } from '@/shared/api/deploy';
import { getDeploymentsByRunIds } from '@/shared/api/deploy';

export const DEPLOYMENTS_BY_RUN_IDS_QUERY_KEY = 'deploymentsByRunIds';

type UseDeploymentsByRunIdsOptions = {
  runIds: string[];
  environment?: string;
  includeDeleted?: boolean;
  enabled?: boolean;
};

export const useDeploymentsByRunIds = (options: UseDeploymentsByRunIdsOptions) => {
  const { runIds, environment = 'dev', includeDeleted = false, enabled = true } = options;

  return useQuery<DeploymentsByRunIdsResponse>({
    queryKey: [DEPLOYMENTS_BY_RUN_IDS_QUERY_KEY, runIds, environment, includeDeleted],
    queryFn: () =>
      getDeploymentsByRunIds({
        run_ids: runIds,
        environment,
        include_deleted: includeDeleted,
      }),
    enabled: enabled && runIds.length > 0,
    staleTime: 1000 * 10,
    gcTime: 1000 * 60 * 5,
  });
};
